module.exports = __webpack_public_path__ + "media/images/countryrect/nr-0a2ab3a7521d21f8311f77ece01acbb1.svg";